<div class="flexie-auto-grid m-t-b-60">

    <div class="flex-self-vert-start">
        <div *ngIf="!savedAdd">
            <div class="zero-ui">
                <i nz-icon nzType="schedule" nzTheme="outline"></i>
                <h2>Add Address</h2>
                <p>You need to atleast one address to continue</p>
            </div>
        </div>
        <div *ngIf="savedAdd">
            <h3> Addresses </h3>
            <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
                <ng-template #item let-item>
                    <nz-list-item [nzActions]="[editAction,moreAction]">
                        <nz-skeleton [nzActive]="true" [nzLoading]="false">
                            <ng-template #editAction><a (click)="edit(item)">Edit</a></ng-template>
                            <ng-template #moreAction><a (click)="view(item)">View</a></ng-template>
                            <nz-list-item-meta [nzTitle]="'Home Address'"
                                nzDescription="B 808, Palazzo, Water Edge Society, Baner, Pune">
                            </nz-list-item-meta>
                        </nz-skeleton>
                    </nz-list-item>
                </ng-template>
            </nz-list>
        </div>
    </div>

    <div>
        <div class="form-secondary">

            <h3 class="form-secondary-heading">+ Add Address</h3>

            <div class="form-secondary-fields p-l-r-20 p-t-b-10">
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Address Type</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                            <label nz-radio nzValue="A">Official</label>
                            <label nz-radio nzValue="B">Home</label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Address Line 1</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="Eg: Empire Estate Building" [(ngModel)]="line1"
                            name="input-basic" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Address Line 2</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="Eg: Near Time Square" [(ngModel)]="line2" name="input-basic" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24">City</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="Eg: New York" [(ngModel)]="city" name="input-basic" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Province</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input nz-input placeholder="Eg: NY" [(ngModel)]="province" name="input-basic" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Country</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <input placeholder="For Eg: USA" nz-input [(ngModel)]="coc"
                            (input)="onInput($event.target?.value)" [nzAutocomplete]="auto">
                        <nz-autocomplete [nzDataSource]="filteredOptions" #auto>
                        </nz-autocomplete>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSpan]="24">Remarks</nz-form-label>
                    <nz-form-control [nzSpan]="24">
                        <textarea nz-input placeholder="Autosize height based on content lines" ngModel
                            nzAutosize></textarea>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div class="footer-actions-bar">
                <div>
                    <!-- Left -->
                </div>
                <div>
                    <!-- Right -->
                    <button nz-button class="b-0 m-r-10">Clear</button>
                    <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
                </div>
            </div>
        </div>
    </div>

</div>